import React, { useState, useEffect } from "react";
import { ManageAssemblyView } from "../../views";
import { useTranslation } from 'react-i18next'
import { WorkflowMessagesService, LocalStorageService, AssembliesService } from "../../../services";
import { useParams } from 'react-router-dom'
import { socket } from "../../../Context";
import moment from 'moment';
import { convertToStandarDate } from "../../../utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const ManageAssemblyAction = (props) => {
    let {
        location,
        title
    } = props
    const { t } = useTranslation()
    const history = useHistory()
    const url = process.env.REACT_APP_MIFIRMA_API;
    const workflowMessagesService = new WorkflowMessagesService(url);
    const token = LocalStorageService.retrieveToken()
    const user = LocalStorageService.retrieveItem("user");
    const timezone = LocalStorageService.retrieveItem("timezone")
    const preferredLanguage = LocalStorageService.retrieveItem("preferredLanguage")
    const language = preferredLanguage || "es"
    moment.locale(language);
    const { assemblyId, workflowExecutionId } = useParams()
    let idAuthorMessage = 0

    const [isLoading, setIsLoading] = useState(true)
    const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
    const [showCompletedRequesting, setShowCompletedRequesting] = useState(false)
    const [showErrorRequesting, setShowErrorRequesting] = useState(false)
    const [messageComplete, setMessageComplete] = useState('')
    const [messageError, setMessageError] = useState('')
    const [titleHeader, setTitleHeader] = useState(title || t("manageAssemblyAction.title"))
    const [documents, setDocuments] = useState([])
    const [selectedFile, setSelectedFile] = useState(null)
    const [selectedFileName, setSelectedFileName] = useState('')
    const [selectedFileBase64, setSelectedFileBase64] = useState('')
    const [colorBorderContainer, setColorBorderContainer] = useState("gray")
    const [errorFile, setErrorFile] = useState(false)
    const [usersChat, setUsersChat] = useState({})
    const [membersChat, setMembersChat] = useState([])
    const [conversation, setConversation] = useState([])
    const [fileChat, setFileChat] = useState(null)


    useEffect(() => {
        socket.emit("leaveRoom", workflowExecutionId)
        getMessages()

        //call sockets    
        socket.on("messages", (data) => addNewMessageSocket(data));
        socket.emit("joinRoom", workflowExecutionId)
    }, [])

    useEffect(() => {
        getDocumentsAssembly()
    }, [])

    const toggleLoadingRequesting = (value) => {
        setShowLoadingRequesting(value)
    };

    const toggleCompletedRequesting = (time, sendInbox, path, message) => {
        let sendTo = (path && path !== '') ? path : "/help-desk"
        setShowCompletedRequesting(true)
        setMessageComplete(message || '')
        setTimeout(() => {
            setShowCompletedRequesting(false)
            setMessageComplete('')
            if (sendInbox) {
                const locationState = location.state
                if (locationState && locationState.from) {
                    history.push({
                        pathname: locationState.from,
                        state: locationState
                    })
                } else {
                    history.push(sendTo);
                }
            }
        }, time || 4000)
    }

    const toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/help-desk"
        setShowErrorRequesting(true)
        setMessageError(message || '')
        setTimeout(() => {
            setShowErrorRequesting(false)
            setMessageComplete('')
            if (sendInbox) {
                const locationState = location.state
                if (locationState && locationState.from) {
                    history.push({
                        pathname: locationState.from,
                        state: locationState
                    })
                } else {
                    history.push(sendTo);
                }
            }
        }, time || 4000)
    }

    const toggleErrorRequestingFalse = () => {
        setShowErrorRequesting(false)
    }

    const handleBackPage = () => {
        history.goBack()
    }

    const handleFile = async (e) => {
        setSelectedFile(e.target.files[0])
        setSelectedFileName(e.target.files[0].name)
        setErrorFile(false)
        setColorBorderContainer("green")

        // Upload the base64 in the state
        let fileBase64 = await pdfToBase64(e.target.files[0]);
        let pdfBase64 = fileBase64.split(",")[1];
        setSelectedFileBase64(pdfBase64)
    };

    const pdfToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        }
        );

    const handleDeleteFile = (e) => {
        setSelectedFile(null)
        setErrorFile(false)
        setSelectedFileBase64("")
        setColorBorderContainer("gray")
    };

    const getMessages = async () => {
        let errorMessages = "Ocurrió un error al consultar los mensajes";
        let userChat = {};
        try {
            //Get message and members chat
            let workflowMessage = await workflowMessagesService.getWorkFlowExecutionMessage(
                workflowExecutionId,
                timezone,
                token
            );
            if (
                workflowMessage &&
                workflowMessage.data &&
                Number(workflowMessage.statusCode) === 200
            ) {
                //Filter out duplicated members
                let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
                    workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
                );
                //users chat
                membersChat.map((member) => {
                    member.id = member.workflowExecutionMemberId;
                    member.avatarUrl = member.profilePicture;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarAltText = member.firstName + " " + member.firstLastName;
                    if (user.userMetaData.userA3Cloud.email === member.email) {
                        idAuthorMessage = member.id;
                        userChat = member;
                    }
                    return membersChat;
                });

                //Message chat
                workflowMessage.data.workflowExecutionMessages.map((member) => {
                    member.author = {
                        name: member.firstName + " " + member.firstLastName,
                        id: member.workflowExecutionMemberId,
                        avatarUrl: member.profilePicture,
                    };
                    let dateConvert = new Date(member.createdDate)
                    member.timestamp = dateConvert
                    member.text = member.workflowExecutionMemberMessage;
                    member.id = member.workflowExecutionMemberId;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarUrl = member.profilePicture;
                    if (member.workflowExecutionMemberMessageDoc.length > 0) {
                        member.attachments = [
                            {
                                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
                            },
                        ];
                    }
                    return workflowMessage.data.workflowExecutionMessages;
                });

                setMembersChat(membersChat)
                setConversation(workflowMessage.data.workflowExecutionMessages)
                setUsersChat(userChat)

            } else {
                setIsLoading(false)
                toggleErrorRequesting(errorMessages, 4000, false, "/")
            }
        } catch (error) {
            setIsLoading(false)
            toggleErrorRequesting(errorMessages, 4000, false, "/")
        }
    };

    const createMessage = async (messagesChat, fileContent) => {
        let data = new FormData();
        data.append("workflowExecutionId", workflowExecutionId);
        data.append("workflowExecutionMemberId", idAuthorMessage);
        data.append("message", messagesChat.text);
        data.append("documento", fileContent);
        data.append("timezone", timezone)

        await workflowMessagesService.createWorkflowExecutionNewMessage(data, token);
    };

    const markChatAsRead = async () => {
        try {
            await workflowMessagesService.markAsRead(workflowExecutionId, token)
        } catch (e) { }
    };

    const addNewMessageSocket = (message) => {
        let copyConversation = [...conversation];
        let indexMessage = copyConversation.length;
        let newMessage = {
            author: {
                name: `${message.firstName} ${message.firstLastName}`,
                id: Number(message.workflowExecutionMemberId),
                avatarUrl: message.profilePicture,
            },
            timestamp: message.workflowExcecutionMemberMessage
                ? new Date(message.workflowExcecutionMemberMessage.createdDate)
                : new Date(
                    message.workflowExecutionMemberMessageDocName[0].createdDate
                ),
            text: message.workflowExcecutionMemberMessage.message,
            id: Number(message.workflowExecutionMemberId),
            name: `${message.firstName} ${message.firstLastName}`,
            avatarUrl: message.profilePicture,
            workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
            workflowExecutionMemberMessage:
                message.workflowExcecutionMemberMessage.message === "" ||
                    message.workflowExcecutionMemberMessage.message === "undefined"
                    ? null
                    : message.workflowExcecutionMemberMessage.message,

            email: message.email,
            firstName: message.firstName,
            firstLastName: message.firstLastName,
            profilePicture: message.profilePicture,
            selectionIndex: indexMessage,
        };
        if (message.workflowExecutionMemberMessageDocName.length > 0) {
            newMessage.workflowExecutionMemberMessageDoc = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
            newMessage.attachments = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
        }

        copyConversation.push(newMessage);
        setConversation(copyConversation)
    };

    const handleInputChangeChat = async (e) => {
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        setFileChat(file)
    }

    const getDocumentsAssembly = async () => {
        let messageError = t("manageAssemblyAction.errors.documents")

        try {
            let documentsBD = await AssembliesService.getDocumentsAssembly(assemblyId, token)
            if (documentsBD && documentsBD.data && Number(documentsBD.statusCode) === 200) {
                let documents = documentsBD.data
                documents = documents.map(doc => {
                    doc.name = doc.document
                    doc.url = doc.documentUrl || ''
                    doc.status = t(`manageAssemblyAction.status.${doc.status}`)
                    doc.dateFormatted = convertToStandarDate(doc.updatedDate, language)
                    return doc
                })

                setDocuments(documents)
                setIsLoading(false)
                // toggleCompletedRequesting()
            } else if (documentsBD && documentsBD.data && Number(documentsBD.statusCode) === 430) {
                messageError = t("manageAssemblyAction.errors.documents.assembly")
                throw new Error(messageError)
            } else {
                throw new Error(messageError)
            }
        } catch (error) {
            setIsLoading(false)
            toggleErrorRequesting(messageError, 4000, false, "/")
        }
    }

    return (
        <ManageAssemblyView
            {...props}
            t={t}
            isLoadingView={isLoading}
            titleHeader={titleHeader}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleErrorRequestingFalse={toggleErrorRequestingFalse}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            messageComplete={messageComplete}
            messageError={messageError}
            assemblyId={assemblyId}
            setDocuments={setDocuments}
            handleBackPage={handleBackPage}
            documents={documents}
            selectedFile={selectedFile}
            selectedFileName={selectedFileName}
            selectedFileBase64={selectedFileBase64}
            colorBorderContainer={colorBorderContainer}
            errorFile={errorFile}
            handleFile={handleFile}
            handleDeleteFile={handleDeleteFile}
            membersChat={membersChat}
            usersChat={usersChat}
            conversation={conversation}
            createMessage={createMessage}
            markChatAsRead={markChatAsRead}
            handleInputChangeChat={handleInputChangeChat}
        />
    )
}

export { ManageAssemblyAction as default }